// ABOUTME: Dropdown option row for the Create Batch product picker.
// ABOUTME: Shows the product label with a badge for its open single-line order count.
import { Box, ButtonBase, useTheme } from "@mui/material";

import cx from 'classnames';
import { tokens } from "../../../../../theme";
import Text from "../../../../theme/text/Text";

export const ProductOpenSinglesItem = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { option } = props;
    return (
        <ButtonBase
            key={props.key}
            onClick={props.onClick}
            className={cx('',{
                'active': props.isSelected
            })}
            sx={{
                flexShrink:0,
                height:32,
                minWidth:300,
                width:1,
                pl:1.5,
                pr:0.5,
                textAlign:"left",
                display:"flex",
                justifyContent:'space-between',
                alignItems:"center",
                borderRadius:props.radius || 2,
                background: props.background,
                '&.active' : {
                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                    color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    fontWeight:"900",
                }
            }}
        >
            <span>
                {option.combined}
            </span>

            {option.openSingles !== undefined && option.openSingles !== null &&
                <Box
                    className={cx('',{
                        'active': props.isSelected
                    })}
                    sx={{
                        height:24,
                        background: props.pillBackground ?? (theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]),
                        display:"flex",
                        justifyContent:'center',
                        alignItems:"center",
                        px:1,
                        borderRadius:props.pillRadius || 2,
                        fontSize:14,
                        fontWeight:500,
                        fontFamily:"Roboto, sans-serif",
                        '&.active' : {
                            background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                            fontWeight:"900",
                        }
                    }}
                >
                    {option.openSingles}
                </Box>
            }
        </ButtonBase>
    )
}
